import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Nullable } from "../../../../../shared/src/@types/util";
import { EUFinanceReactQueryKey } from "../../../../models/EUFinanceReactQueryKey";
import { EUFinanceCaseAttachment } from "../../models/sobjects/EUFinanceCaseAttachment";
import { useEUFinanceCaseAttachmentService } from "../../services/EUFinanceCaseAttachmentService";

export type UseCaseAttachmentByIdResult =
  UseQueryResult<EUFinanceCaseAttachment>;

const useCaseAttachmentById = (
  caseAttachmentId: Nullable<string>
): UseCaseAttachmentByIdResult => {
  const caseAttachmentService = useEUFinanceCaseAttachmentService();

  return useQuery<EUFinanceCaseAttachment>({
    queryKey: [
      ...EUFinanceReactQueryKey.GET_CASE_ATTACHMENTS_BY_CASE_ATTACHMENT_ID,
      caseAttachmentId,
    ],
    queryFn: () =>
      caseAttachmentService.getCaseAttachmentById(caseAttachmentId),
    meta: {
      errorMessage: "Failed to load case attachment",
    },
  });
};

export default useCaseAttachmentById;
